<template>
    <div>
        <div class="show-navigation bg--beam">
            <header class="header mb--10">
                <div class="container">
                    <div class="panel bg--layer-dark pt--0 pb--0">
                        <div class="row align-items--center">
                            <div class="col-4 offset-4">
                                <h1 class="header__title">Store</h1>
                            </div>

                            <div class="col-4">
                                <div class="coin justify-content--end">
                                    <img src="img/icons/coin.png" alt="" />
                                    <span>{{ user.balance }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <div class="container">

                <!--div class="mb--20">
                    <h2 class="title-primary text--center mb--10"><span class="c--gradient-primary">Daily deals</span></h2>

                    <a href="" class="btn btn--block btn--white btn--left-icon-circle mb--md">
                        <img class="btn-icon" src="img/icons/coin.png" alt="" />
                        <div>50 free Quid</div>
                        <div class="ml--auto d--flex align-items--center">
                            <svg class="btn__info-icon"><use xlink:href="/img/icon-sprite.svg#user-plus"></use></svg>
                            <span class="inner-btn inner-btn--success miw--64 ml--sm">Get</span>
                        </div>
                    </a>

                    <a href="" class="btn btn--block btn--white btn--left-icon-circle mb--md">
                        <div class="btn-icon btn-icon--percent">
                            <svg class="icon"><use xlink:href="/img/icon-sprite.svg#percent"></use></svg>
                        </div>
                        <div>Free 50-50 power up</div>
                        <div class="ml--auto d--flex align-items--center">
                            <svg class="btn__info-icon"><use xlink:href="/img/icon-sprite.svg#play"></use></svg>
                            <span class="inner-btn inner-btn--success miw--64 ml--sm">Get</span>
                        </div>
                    </a>
                </div

                <div class="mb--20">
                    <h2 class="title-primary text--center mb--10"><span>Best deals</span></h2>

                    <a @click="buyQuid(250)" class="btn btn--block btn--white btn--left-icon-circle mb--md">
                        <img class="btn-icon" src="img/icons/coin.png" alt="" />
                        <div>250 Quid</div>
                        <div class="ml--auto d--flex align-items--center">
                            <span class="inner-btn inner-btn--success miw--88 ml--sm">349 Ft</span>
                        </div>
                    </a>

                    <a @click="buyQuid(1500)" class="btn btn--block btn--white btn--left-icon-circle mb--md">
                        <img class="btn-icon" src="img/icons/coins.png" alt="" />
                        <div>1500 Quid</div>
                        <div class="ml--auto d--flex align-items--center">
                            <span class="inner-btn inner-btn--success miw--88 ml--sm">1 790 Ft</span>
                        </div>
                    </a>

                    <a @click="buyQuid(7000)" class="btn btn--block btn--white btn--left-icon-circle mb--md">
                        <img class="btn-icon" src="img/icons/coins-more.png" alt="" />
                        <div>7000 Quid</div>
                        <div class="ml--auto d--flex align-items--center">
                            <span class="inner-btn inner-btn--success miw--88 ml--sm">6 990 Ft</span>
                        </div>
                    </a>
                </div>

                -->

                <div class="mb--20">
                    <h2 class="title-primary text--center mb--10"><span>Power ups</span></h2>

                    <button @click="addPowerUp(powerUp)" class="btn btn--block btn--white btn--left-icon-circle mb--md" v-for="powerUp in powerUps">
                        <div class="btn-icon" :class="powerUp.iconClass">
                            <svg class="icon"><use :xlink:href="powerUp.image"></use></svg>
                        </div>
                        <div>{{ powerUp.name }}</div>
                        <div class="ml--auto d--flex align-items--center">
                            <div class="coin coin--sm">
                                <img src="img/icons/coin.png" alt="" /> <span>{{ powerUp.quid }}</span>
                            </div>
                            <span class="inner-btn inner-btn--sm inner-btn--success inner-btn--circle ml--md">+</span>
                        </div>
                    </button>

                    <p class="text--center mt--30">You can earn "Quids" with achievements and tournaments.</p>
                </div>
            </div>
        </div>

        <navigation></navigation>

        <modal show="false" type="error" ref="errorModal">
            <template v-slot:message>
                <div v-if="errors.any()">
                    <div v-for="error in errors.all()">{{ error }}</div>
                </div>
            </template>

            <template v-slot:title>
                Oops!
            </template>

            <template v-slot:buttons><span></span></template>
        </modal>
    </div>
</template>

<script>
    import Navigation from "./partial/Navigation";
    import {mapState} from "vuex";
    import api from "../api/store";
    import Errors from "../util/Errors";

    export default {
        name: "Store",
        components: {Navigation},

        data: function () {
            return {
                errors: new Errors(),
                powerUps: null
            }
        },

        computed: {
            ...mapState('auth', [
                'user'
            ])
        },

        methods: {
            async buyQuid(quid) {
                try {
                    let response = await api.addBalance(quid)

                    this.$store.commit(
                        'auth/updateUserData',
                        { field: 'balance', value: response.data.balance}
                        )
                } catch (error) {
                    if (error.response.status === 422) {
                        this.errors.record(error.response.data.errors)
                        this.$refs.errorModal.open()
                    }
                }
            },

            addPowerUp(powerUp) {
                axios.post('/add-power-up', {id: powerUp.id})
                    .catch((error) => {
                        if (error.response.status === 422) {
                            this.errors.record(error.response.data.errors)
                            this.$refs.errorModal.open()
                        }
                })
            },

            isDisabled(powerUp) {
                return this.user.balance < powerUp.quid
            },

            loadPowerUps() {
                api.powerUps()
                    .then((response) => {
                        this.powerUps = response.data.data
                    })
            }
        },

        created() {
            this.loadPowerUps()
        }
    }
</script>